import * as React from "react";
import { createSvgIcon } from "@material-ui/core/utils";
export var iconPath = (React.createElement("path", { d: "M18.913 5H5.087C4.21 5 3.5 5.702 3.5 6.568v10.864c0 .866.71 1.568 1.587 1.568h13.826c.876 0 1.587-.702 1.587-1.568V6.568C20.5 5.702 19.79 5 18.913 5zM9.5 17h-4v-4h4v4z" }));
export default createSvgIcon(iconPath, "Icons");
//# sourceMappingURL=IconsIcon.js.map